import { Injectable } from '@angular/core';
import { ModalOptions } from '@app/core/model/modalOptions';
import { CreateOrderComponent } from '@app/ui/order/create-order/create-order.component';
import { ModalService } from '@app/core/ui/modal/modal.service';
import { ContextService } from '@app/core/service/context.service';
import { ConfirmModalComponent } from '@app/core/ui/confirm-modal/confirm-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { Order } from '@app/core/business/order/order';
import { CustomerService } from '@app/core/business/customer/customer.service';
import { zip } from 'rxjs';
import { Address } from '@app/core/business/address';
import { ValidateOrderComponent } from '@app/ui/order/validate-order/validate-order.component';
import { OrderSelectorModalComponent } from '../order-selector-modal/order-selector-modal.component';
import { ElasticConfigFieldMeta, ElasticSearchConfigTestComponent } from '@app/ui/elastic-search/elastic-search-config-test/elastic-search-config-test.component';
import { ElasticSearchConfigModel } from '@app/core/business/elastic-search/elastic-search-config.model';

@Injectable()
export class ModalFactoryService {
  constructor(
    private modalService: ModalService,
    private translateService: TranslateService,
    private contextService: ContextService,
    private customerService: CustomerService
  ) { }

  // Show modal form for a new Order
  public newOrder(onValidate, onCancel?): void {
    const modalOptions = new ModalOptions();

    this.customerService
      .getDeliveryAddresses(
        this.contextService.context.companyCode,
        this.contextService.context.customerCode
      )
      .subscribe(addresses => {
        modalOptions.datas = {
          order: new Order(),
          addresses: addresses,
        };
        modalOptions.hostedComponent = CreateOrderComponent;
        modalOptions.title = this.translateService.instant(
          'modal.newOrderTitle'
        );

        this.modalService.init(modalOptions);
        this.modalService.onValidate.subscribe(onValidate);
        this.modalService.onCancel.subscribe(onCancel);
      });
  }

  // Show modal form to validate order
  public validateOrder(onValidate, order: Order, onCancel?): void {
    const modalOptions = new ModalOptions();

    this.customerService
      .getDeliveryAddresses(
        this.contextService.context.companyCode,
        this.contextService.context.customerCode
      )
      .subscribe(addresses => {
        modalOptions.datas = {
          order: order,
          addresses: addresses,

        };
        modalOptions.hostedComponent = ValidateOrderComponent;
        modalOptions.title = this.translateService.instant(
          'modal.validateOrderTitle'
        );

        this.modalService.init(modalOptions);
        this.modalService.onValidate.subscribe(onValidate);
        this.modalService.onCancel.subscribe(onCancel);
      });
  }


  // Show modal form to configure Elk Test
  public configureTestElk(onValidate, config: ElasticSearchConfigModel, onCancel?): void {
    const modalOptions = new ModalOptions();
    modalOptions.datas = {
      config: config
    }
    modalOptions.hostedComponent = ElasticSearchConfigTestComponent;
    modalOptions.title = this.translateService.instant(
      'modal.configureElkTest'
    );

    this.modalService.init(modalOptions);
    this.modalService.onValidate.subscribe(onValidate);
    this.modalService.onCancel.subscribe(onCancel);


  }

  public confirm(onValidate, onCancel?, title?, message?): void {
    const modalOptions = new ModalOptions();
    modalOptions.datas = {
      message: message,
    };
    modalOptions.hostedComponent = ConfirmModalComponent;
    modalOptions.title =
      title || this.translateService.instant('modal.confirmTitle');

    this.modalService.init(modalOptions);

    this.modalService.onValidate.subscribe(onValidate);
    this.modalService.onCancel.subscribe(onCancel);
  }

  public orderSelector(onValidate, onCancel?): void {
    const modalOptions = new ModalOptions();
    modalOptions.hostedComponent = OrderSelectorModalComponent;
    modalOptions.type = 'lg';
    modalOptions.title = this.translateService.instant(
      'modal.orderSelectorTitle'
    );

    this.modalService.init(modalOptions);

    this.modalService.onValidate.subscribe(onValidate);
    this.modalService.onCancel.subscribe(onCancel);
  }
}
